import * as yup from "yup";
import { LocationFormValues } from "./types";

export const defaultFormValues: LocationFormValues = {
  id: undefined,
  name: "",
  enabled: true,
  retailerLocationKey: "0",
};

export const schema = yup.object().shape({
  id: yup.string().nullable().optional(), // or yup.mixed() if it could be other than string
  name: yup.string().required("Name is required"),
  enabled: yup.boolean().required(),
  retailerLocationKey: yup
    .string()
    .required("Retailer location key is required"),
});
